export const willowSessions = (quantity) => ({
    "id": "willow_session",
    "productId": "willow_session",
    "orderIndex": 0,
    "description": "",
    "numberOfSessions": quantity,
    "amount": 15000*quantity, //100*quantity
    "isPrivate": false,
    "planType": "one_time",
    "recurringInterval": null,
    "subscriptionDurationInMonths": null,
    "status": "Active",
    "product": {
        "id": "willow_session",
        "title": "Willow Financial Life Coaching",
        "description": "Appointments: "+quantity,
        "coverPhoto": "",
        "serviceType": "online",
        "termsOfUseUrl": "https://trustwillow.com/terms-of-use",
        "privacyPolicyUrl": "",
        "downloadUrl": "",
        "sessionLength": 45,
        "status": "Active",
        "expert": {
            "id": null,
            "fullName": "Willow",
            "firstName": "Willow",
            "lastName": "",
            "storeHandle": "",
            "publicHandle": "",
            "profilePhotoUrl": ""
        }
    }
});
